import { datadogLogs } from '@datadog/browser-logs'

export default defineNuxtPlugin(() => {
  // Disable during local development.
  if (import.meta.dev) {
    console.log('Datadog plugin is disabled in development mode.')
    return
  }
  const { datadogToken: token, buildHash } = useRuntimeConfig().public

  if (token) {
    const drupalUser = useDrupalUser()
    datadogLogs.setGlobalContextProperty('commit', buildHash)
    datadogLogs.setGlobalContextProperty(
      'is_editor',
      drupalUser.value.accessToolbar,
    )

    datadogLogs.init({
      clientToken: token,
      site: 'datadoghq.eu',
      forwardErrorsToLogs: true,
      sessionSampleRate: 100,
    })
  }
})
